<p>
  {{resultado}}
</p>
